import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-hot-toast";

const DEACTIVATED_MSG = "Your account is not active. Please contact admin.";
const SESSION_SUPERSEDED_MSG =
  "You were logged out because this account signed in elsewhere.";

const isSessionSupersededResponse = (response) => {
  if (response?.status !== 403) return false;
  const msg = String(
    response?.data?.error || response?.data?.message || "",
  ).toLowerCase();
  return msg.includes("session invalid");
};

const isDeactivatedResponse = (response) => {
  if (response?.status !== 403) return false;
  const msg =
    response?.data?.error ||
    response?.data?.message ||
    "";
  const s = String(msg).toLowerCase();
  if (s.includes("session invalid")) return false;
  return (
    s.includes("inactive") ||
    s.includes("account inactive")
  );
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error?.response;
    if (isSessionSupersededResponse(response)) {
      toast.error(SESSION_SUPERSEDED_MSG);
      window.dispatchEvent(
        new CustomEvent("auth:logout", {
          detail: { reason: "session_superseded" },
        }),
      );
    } else if (isDeactivatedResponse(response)) {
      toast.error(DEACTIVATED_MSG);
      window.dispatchEvent(
        new CustomEvent("auth:logout", { detail: { reason: "deactivated" } })
      );
    }
    return Promise.reject(error);
  }
);

const responseBody = (response) => {
  return response.data;
};

export const request = {
  get: (url, params) =>
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        params,
      })
      .then(responseBody),
  post: (url, body) =>
    axios
      .post(url, body, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then(responseBody),
  put: (url, body) =>
    axios
      .put(url, body, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then(responseBody),
  del: (url) =>
    axios
      .delete(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then(responseBody),
};
export const requestToken = {
  get: (url, params, config = {}) => {
    const { signal, ...restConfig } = config;
    return axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        params,
        signal,
        ...restConfig,
      })
      .then(responseBody);
  },
  post: (url, body) =>
    axios
      .post(url, body, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then(responseBody),
  put: (url, body) =>
    axios
      .put(url, body, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then(responseBody),
  del: (url) =>
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then(responseBody),
};

export const requestTokenImage = {
    post: (url, body) =>
      axios
        .post(url, body, {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        })
        .then(responseBody),
  };

const request_methods = {
  request,
  requestToken,
  requestTokenImage,
};

export default request_methods;
